import { Component, OnInit } from '@angular/core';
import { NavParams, AlertController } from '@ionic/angular';
import { MessageContextService } from 'src/app/gesture.service';
import { PopoverAndToastService } from 'src/app/popover-and-toast.service';
import { TextableService } from 'src/app/services/textable-service.service';


@Component({
  selector: 'app-ios-message-popover',
  templateUrl: './ios-message-popover.page.html',
  styleUrls: ['./ios-message-popover.page.scss'],
})
export class IosMessagePopoverPage implements OnInit {

  message = {
    id: '',
    send_status:''
  }
  heldMessage;

  constructor(
    public navParams: NavParams,
    public textable: TextableService,
    private alerting: AlertController,
    private patService: PopoverAndToastService,
    /**
     * This service is used in the HTML template, so it needs to be public
     */
    public gestureService: MessageContextService
    ) { }

  ngOnInit() {
    //navparam comes from the presentIOSMessagePopover componentprops.
    this.message.id = this.navParams.data.id;
    this.message.send_status = this.navParams.data.send_status;
    this.heldMessage = this.navParams.data.heldMessage;
  }

  async deleteMessage() {
    const alert = await this.alerting.create({
      header: 'Delete this message?',
      message: 'This action cannot be undone.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (cancel) => {
            this.heldMessage.style.removeProperty('background');
            this.patService.dismissPopover();
          }
        }, {
          text: 'Delete',
          handler: () => {
            this.textable.deleteMessage(this.message.id);
            this.heldMessage.style.removeProperty('background');
            this.patService.dismissPopover();
          }
        }
      ]
    });

    await alert.present();
  }
}
